import { Controller, Control } from 'react-hook-form'

import Rate, { Props as RateProps } from './rate'

import InputFeedback from 'common/components/form/inputFeedback'
import { FormData } from '../thankYou'

import '@hotmart/cosmos/dist/styles/utilities/display/display.css'
import '@hotmart/cosmos/dist/styles/utilities/flex/flex.css'

export interface Props extends RateProps {
  label?: string,
  invalidFeedback?: string,
  control: Control<FormData>,
  hasError?: boolean
}

const FormRate = ({ invalidFeedback, label, control, hasError, ...rest }: Props) => {
  return (
    <div className="hot-form _d-flex _justify-content-between">
      <label className="hot-form__label">{label}</label>
      <Controller
        name="rate"
        control={control}
        render={({ field }) => (
          <Rate {...rest} {...field} />
        )}/>
      {invalidFeedback && (
        <InputFeedback hasError={hasError} errorMessage={invalidFeedback} />
      )}
    </div>
  )
}

export default FormRate
